var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowPatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-26a476a8-1a03-4cba-9d9e-88b2f141b45c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 10",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e0a5d0ef-8436-471a-bbf9-8b3ef9c693f5",
    d: "M0,10S34.5.08,75,0c32.07-.06,75,10,75,10H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowPatch);
export default __webpack_public_path__ + "static/media/snow-patch.618a737365f034ad8dad43c2b4052c6e.svg";
export { ForwardRef as ReactComponent };